var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "basic-container",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: !_vm.isShowContent,
          expression: "!isShowContent",
        },
      ],
      attrs: { block: !_vm.isShowContent || _vm.allDataList.length === 0 },
    },
    [
      _vm.systemMessage
        ? _c(
            "div",
            { staticClass: "u-m-b-10" },
            [
              _c("el-alert", {
                attrs: {
                  closable: false,
                  title: _vm.systemMessage,
                  type: "warning",
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm.envConfig.isBxIe()
        ? _c(
            "div",
            { staticClass: "select_content u-m-b-20" },
            _vm._l(_vm.selectContentList, function (itemData, indexContent) {
              return _c(
                "div",
                {
                  key: indexContent,
                  staticClass:
                    "u-flex u-col-center u-row-left select_content_item_row",
                },
                [
                  _c("span", { staticClass: "select_content_item_row_title" }, [
                    _vm._v(_vm._s(itemData.title)),
                  ]),
                  _c(
                    "div",
                    [
                      _c(
                        "el-checkbox-group",
                        {
                          model: {
                            value: _vm.selectDataList["" + itemData.key],
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.selectDataList,
                                "" + itemData.key,
                                $$v
                              )
                            },
                            expression: "selectDataList[`${itemData.key}`]",
                          },
                        },
                        _vm._l(
                          itemData.selectLabelList,
                          function (itemBox, index) {
                            return _c(
                              "el-checkbox",
                              {
                                key: index,
                                staticStyle: { width: "90px" },
                                attrs: { label: itemBox.value },
                              },
                              [
                                _vm._v(
                                  "\n\t\t\t\t\t\t" +
                                    _vm._s(itemBox.label) +
                                    "\n\t\t\t\t\t"
                                ),
                              ]
                            )
                          }
                        ),
                        1
                      ),
                    ],
                    1
                  ),
                ]
              )
            }),
            0
          )
        : _vm._e(),
      _vm.isShowContent
        ? _c(
            "div",
            [
              _vm.allDataList.length > 0
                ? _c(
                    "div",
                    _vm._l(_vm.allDataList, function (ref) {
                      var dataList = ref.dataList
                      if (dataList === void 0) dataList = []
                      var productType = ref.type
                      if (productType === void 0) productType = ""
                      return _c(
                        "div",
                        { key: productType },
                        [
                          _vm.isShowTitle
                            ? _c(
                                "div",
                                { staticClass: "title u-flex u-col-center" },
                                [
                                  _c("el-divider", {
                                    staticClass: "u-m-l-1 u-m-r-10 title-shu",
                                    attrs: { direction: "vertical" },
                                  }),
                                  _c(
                                    "span",
                                    {
                                      staticClass:
                                        "u-font-weight-bold u-font-md",
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          productType === "1"
                                            ? "我的收藏"
                                            : "全部产品"
                                        )
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                          dataList.length > 0
                            ? _c(
                                "draggable",
                                {
                                  attrs: {
                                    disabled: productType === "0",
                                    animation: "200",
                                    group: "people",
                                  },
                                  on: { end: _vm.onEnd, start: _vm.onStart },
                                  model: {
                                    value: dataList,
                                    callback: function ($$v) {
                                      dataList = $$v
                                    },
                                    expression: "dataList",
                                  },
                                },
                                [
                                  _c(
                                    "transition-group",
                                    {
                                      staticClass:
                                        "u-flex u-flex-wrap u-row-between product_content",
                                    },
                                    [
                                      _vm._l(
                                        dataList,
                                        function (itemData, indexNei) {
                                          return _c(
                                            "div",
                                            { key: itemData.id },
                                            [
                                              _c(
                                                "el-card",
                                                {
                                                  staticClass:
                                                    "product_content_item",
                                                  attrs: {
                                                    "body-style": {
                                                      padding: 0,
                                                    },
                                                  },
                                                  nativeOn: {
                                                    click: function ($event) {
                                                      return _vm.handleView(
                                                        itemData
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  _c("el-image", {
                                                    staticClass:
                                                      "product_content_item_img",
                                                    attrs: {
                                                      src:
                                                        itemData.picture ||
                                                        itemData.groupLogo,
                                                      fit: "fill",
                                                    },
                                                  }),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "product_content_item_collect u-relative",
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          $event.stopPropagation()
                                                          return _vm.onCollect(
                                                            itemData
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [
                                                      _c("el-icon", {
                                                        class: [
                                                          _vm.getCollectIconStyle(
                                                            productType
                                                          )[0],
                                                          "icon" + indexNei,
                                                        ],
                                                        staticStyle: {
                                                          color: "#409eff",
                                                        },
                                                        style:
                                                          _vm.getCollectIconStyle(
                                                            productType
                                                          )[1],
                                                      }),
                                                    ],
                                                    1
                                                  ),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "u-flex u-row-center product_content_item_control",
                                                      style: {
                                                        color: itemData.color
                                                          ? itemData.color
                                                          : "",
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "product_content_item_text",
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              $event.stopPropagation()
                                                              return _vm.onDownloadCategory(
                                                                itemData
                                                              )
                                                            },
                                                          },
                                                        },
                                                        [
                                                          _c("i", {
                                                            staticClass:
                                                              "u-m-r-5",
                                                            class:
                                                              _vm.isDownLoading
                                                                ? "el-icon-loading"
                                                                : "el-icon-download",
                                                          }),
                                                          _vm._v(
                                                            "\n\t\t\t\t\t\t\t\t\t\t职业类别表\n\t\t\t\t\t\t\t\t\t"
                                                          ),
                                                        ]
                                                      ),
                                                      _c("el-divider", {
                                                        staticClass:
                                                          "u-m-l-15 u-m-r-15",
                                                        attrs: {
                                                          direction: "vertical",
                                                        },
                                                      }),
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "product_content_item_text",
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              $event.stopPropagation()
                                                              return _vm.onCreatePlan(
                                                                itemData
                                                              )
                                                            },
                                                          },
                                                        },
                                                        [
                                                          _c("i", {
                                                            staticClass:
                                                              "el-icon-notebook-2 u-m-r-5",
                                                          }),
                                                          _vm._v(
                                                            "\n\t\t\t\t\t\t\t\t\t\t投保计划书\n\t\t\t\t\t\t\t\t\t"
                                                          ),
                                                        ]
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "product_content_item_des",
                                                    },
                                                    _vm._l(
                                                      itemData.intros,
                                                      function (item2, index2) {
                                                        return _c(
                                                          "div",
                                                          {
                                                            key: index2,
                                                            staticClass:
                                                              "product_content_item_des_content",
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n\t\t\t\t\t\t\t\t\t\t" +
                                                                _vm._s(item2) +
                                                                "\n\t\t\t\t\t\t\t\t\t"
                                                            ),
                                                          ]
                                                        )
                                                      }
                                                    ),
                                                    0
                                                  ),
                                                  _vm.isMainChannel()
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "product_content_item_fee",
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              $event.stopPropagation()
                                                              return _vm.onShowFeeDetail.apply(
                                                                null,
                                                                arguments
                                                              )
                                                            },
                                                          },
                                                        },
                                                        [
                                                          _c(
                                                            "el-popover",
                                                            {
                                                              attrs: {
                                                                "close-delay": 100,
                                                                placement:
                                                                  "top",
                                                                trigger:
                                                                  "hover",
                                                              },
                                                            },
                                                            [
                                                              _c(
                                                                "el-table",
                                                                {
                                                                  attrs: {
                                                                    data: itemData.feeContentList,
                                                                    border: "",
                                                                  },
                                                                },
                                                                [
                                                                  _c(
                                                                    "el-table-column",
                                                                    {
                                                                      attrs: {
                                                                        label:
                                                                          "方案",
                                                                        property:
                                                                          "label",
                                                                        width:
                                                                          "240",
                                                                      },
                                                                    }
                                                                  ),
                                                                  _c(
                                                                    "el-table-column",
                                                                    {
                                                                      attrs: {
                                                                        label:
                                                                          "费率",
                                                                        property:
                                                                          "value",
                                                                        width:
                                                                          "60",
                                                                      },
                                                                    }
                                                                  ),
                                                                ],
                                                                1
                                                              ),
                                                              _c(
                                                                "div",
                                                                {
                                                                  attrs: {
                                                                    slot: "reference",
                                                                  },
                                                                  slot: "reference",
                                                                },
                                                                [
                                                                  itemData.feeContent
                                                                    ? _c(
                                                                        "span",
                                                                        {
                                                                          staticClass:
                                                                            "u-font-weight-bold",
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            "费用:"
                                                                          ),
                                                                        ]
                                                                      )
                                                                    : _vm._e(),
                                                                  _vm._v(
                                                                    "\n\t\t\t\t\t\t\t\t\t\t\t" +
                                                                      _vm._s(
                                                                        itemData.feeContentList &&
                                                                          itemData
                                                                            .feeContentList
                                                                            .length >
                                                                            1
                                                                          ? "最高 "
                                                                          : ""
                                                                      ) +
                                                                      _vm._s(
                                                                        itemData.feeContent
                                                                      ) +
                                                                      "\n\t\t\t\t\t\t\t\t\t\t\t"
                                                                  ),
                                                                  itemData.feeContentList &&
                                                                  itemData
                                                                    .feeContentList
                                                                    .length > 1
                                                                    ? _c(
                                                                        "el-icon",
                                                                        {
                                                                          staticClass:
                                                                            "el-icon-arrow-right",
                                                                        }
                                                                      )
                                                                    : _vm._e(),
                                                                ],
                                                                1
                                                              ),
                                                            ],
                                                            1
                                                          ),
                                                        ],
                                                        1
                                                      )
                                                    : _vm._e(),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "u-flex u-row-between u-col-center u-m-b-10 product_content_item_insure",
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "u-font-weight-bold product_content_item_insure_price",
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              itemData.price /
                                                                100
                                                            )
                                                          ),
                                                        ]
                                                      ),
                                                      _c(
                                                        "div",
                                                        [
                                                          !_vm.isRenBao(
                                                            itemData.insureType
                                                          ) ||
                                                          _vm.isFxadminChannel()
                                                            ? _c(
                                                                "el-button",
                                                                {
                                                                  staticClass:
                                                                    "product_content_item_insure_to",
                                                                  attrs: {
                                                                    loading:
                                                                      _vm.isInsureLoading,
                                                                    type: "primary",
                                                                  },
                                                                  on: {
                                                                    click:
                                                                      function (
                                                                        $event
                                                                      ) {
                                                                        $event.stopPropagation()
                                                                        return _vm.handleInsure(
                                                                          itemData
                                                                        )
                                                                      },
                                                                  },
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "\n\t\t\t\t\t\t\t\t\t\t\t去投保\n\t\t\t\t\t\t\t\t\t\t"
                                                                  ),
                                                                ]
                                                              )
                                                            : _c(
                                                                "el-button-group",
                                                                [
                                                                  _c(
                                                                    "el-button",
                                                                    {
                                                                      staticClass:
                                                                        "product_content_item_insure_to",
                                                                      attrs: {
                                                                        loading:
                                                                          _vm.isShareLoading,
                                                                        type: "primary",
                                                                      },
                                                                      on: {
                                                                        click:
                                                                          function (
                                                                            $event
                                                                          ) {
                                                                            $event.stopPropagation()
                                                                            return _vm.onToTransmit(
                                                                              itemData
                                                                            )
                                                                          },
                                                                      },
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "\n\t\t\t\t\t\t\t\t\t\t\t\t转发\n\t\t\t\t\t\t\t\t\t\t\t"
                                                                      ),
                                                                    ]
                                                                  ),
                                                                  _c(
                                                                    "el-button",
                                                                    {
                                                                      staticClass:
                                                                        "product_content_item_insure_to",
                                                                      attrs: {
                                                                        loading:
                                                                          _vm.isInsureLoading,
                                                                        type: "primary",
                                                                      },
                                                                      on: {
                                                                        click:
                                                                          function (
                                                                            $event
                                                                          ) {
                                                                            $event.stopPropagation()
                                                                            return _vm.handleInsure(
                                                                              itemData
                                                                            )
                                                                          },
                                                                      },
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "\n\t\t\t\t\t\t\t\t\t\t\t\t去投保\n\t\t\t\t\t\t\t\t\t\t\t"
                                                                      ),
                                                                    ]
                                                                  ),
                                                                ],
                                                                1
                                                              ),
                                                        ],
                                                        1
                                                      ),
                                                    ]
                                                  ),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          )
                                        }
                                      ),
                                      _vm._l(10, function (n) {
                                        return _c("div", {
                                          key: n,
                                          staticClass: "product_content_item",
                                          staticStyle: {
                                            height: "0",
                                            "margin-top": "15px",
                                          },
                                        })
                                      }),
                                    ],
                                    2
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                        ],
                        1
                      )
                    }),
                    0
                  )
                : _c("el-empty", {
                    staticClass: "u-m-t-60",
                    attrs: { description: "数据为空" },
                  }),
            ],
            1
          )
        : _vm._e(),
      _c("insure-notices", {
        ref: "refInsureNotices",
        on: { onToInsure: _vm.onGoInsure },
      }),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.isShowQrCode,
            center: "",
            "custom-class": "share_dialog",
            width: "400px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.isShowQrCode = $event
            },
          },
        },
        [
          _c(
            "div",
            { staticClass: "u-flex-col u-col-center" },
            [
              _c(
                "span",
                {
                  staticClass: "u-font-weight-bold u-font-18 u-m-t-60",
                  staticStyle: { color: "black" },
                },
                [_vm._v("分享给他人录单")]
              ),
              _c("span", { staticClass: "u-m-t-10" }, [
                _vm._v("录单成功后，下载发票等操作"),
              ]),
              _c("span", { staticClass: "u-m-b-20" }, [
                _vm._v("将在你的登录账号下进行"),
              ]),
              _c("img", {
                attrs: {
                  src: _vm.qrCodeUrl,
                  alt: "",
                  height: "320",
                  width: "320",
                },
              }),
              _c(
                "el-button",
                {
                  staticClass: "u-m-t-30",
                  attrs: { plain: "", type: "primary" },
                  on: { click: _vm.onSaveWxMa },
                },
                [_vm._v("保存二维码图片")]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }